/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Join_CommunityInputs */

const en_join_community = /** @type {(inputs: Join_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join Community`)
};

const es_join_community = /** @type {(inputs: Join_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unirse a la Comunidad`)
};

const fr_join_community = /** @type {(inputs: Join_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejoindre la communauté`)
};

const de_join_community = /** @type {(inputs: Join_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community beitreten`)
};

const id_join_community = /** @type {(inputs: Join_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gabung Komunitas`)
};

/** @type {(inputs: Join_CommunityInputs) => LocalizedString} */
const ja_join_community = en_join_community;

/** @type {(inputs: Join_CommunityInputs) => LocalizedString} */
const zh_join_community = en_join_community;

/** @type {(inputs: Join_CommunityInputs) => LocalizedString} */
const ar_join_community = en_join_community;

/** @type {(inputs: Join_CommunityInputs) => LocalizedString} */
const it_join_community = en_join_community;

/** @type {(inputs: Join_CommunityInputs) => LocalizedString} */
const ru_join_community = en_join_community;

/** @type {(inputs: Join_CommunityInputs) => LocalizedString} */
const pt_join_community = en_join_community;

/** @type {(inputs: Join_CommunityInputs) => LocalizedString} */
const ko_join_community = en_join_community;

/**
* | output |
* | --- |
* | "Join Community" |
*
* @param {Join_CommunityInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const join_community = /** @type {((inputs?: Join_CommunityInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Join_CommunityInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_join_community(inputs)
	if (locale === "es") return es_join_community(inputs)
	if (locale === "fr") return fr_join_community(inputs)
	if (locale === "de") return de_join_community(inputs)
	if (locale === "ja") return ja_join_community(inputs)
	if (locale === "zh") return zh_join_community(inputs)
	if (locale === "ar") return ar_join_community(inputs)
	if (locale === "id") return id_join_community(inputs)
	if (locale === "it") return it_join_community(inputs)
	if (locale === "ru") return ru_join_community(inputs)
	if (locale === "pt") return pt_join_community(inputs)
	return ko_join_community(inputs)
});